import React, { useEffect, useRef, useState } from 'react'
import { Link, NavLink } from 'react-router-dom'
import excelFile from '../../files/SGH Academy Courses 2025 Calendar.xlsx';
export default function Header() {
    // const [active, setActive] = useState("");
    // fixed header
    useEffect(() => {
        const handleScroll = () => {
            const header = document.querySelector('.header-nav-wrapper');
            if (window.scrollY > 100) {
                header.classList.add('sticky');
            } else {
                header.classList.remove('sticky');
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);
    // const [isMobile, setIsMobile] = useState(false);

    // useEffect(() => {
    //     const handleResize = () => {
    //         setIsMobile(window.innerWidth <= 768); // Adjust the breakpoint as per your mobile design
    //     };

    //     handleResize(); // Check initial viewport width
    //     window.addEventListener('resize', handleResize);

    //     return () => {
    //         window.removeEventListener('resize', handleResize);
    //     };
    // }, []);
    const [isNavOpen, setIsNavOpen] = useState(false);

    // const handleToggleClick = () => {
    //     setIsNavOpen(!isNavOpen);
    // };

    const closeNavbar = () => {
        setIsNavOpen(false);
    };
    const [isOpen, setIsOpen] = useState(false);

    const toggleSubmenu = () => {
        setIsOpen(!isOpen);
    };

    const handleDownload = () => {
        const link = document.createElement('a');
        link.href = excelFile;
        link.download = 'excelFile.xlsx';
        link.click();
    };
    const collapseRef = useRef(null);

    const closeNav = () => {
        const collapseEl = collapseRef.current;
        if (collapseEl && collapseEl.classList.contains("show")) {
            const bsCollapse = window.bootstrap.Collapse.getInstance(collapseEl);
            bsCollapse?.hide(); // Close it
        }
    };
    function scrollToTop() {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }
    return <>
        <div className="side-panel-body-overlay"></div>
        <div id="side-panel-container" className="dark" data-tm-bg-img="images/side-push-bg.jpg">
            <div className="side-panel-wrap">
                <div id="side-panel-trigger-close" className="side-panel-trigger"><Link to="/"><i className="fa fa-times side-panel-trigger-icon"></i></Link></div>
                <img className="logo mb-50" src="images/logo-wide.png" alt="Logo" />
                <p>Our motive is to help the poor, helpless and orphan children all over the world.</p>
                <div className="widget">
                    <h4 className="widget-title widget-title-line-bottom line-bottom-theme-colored1">Latest News</h4>
                    <div className="latest-posts">
                        <article className="post clearfix pb-0 mb-10">
                            <Link tos="post-thumb" to="news-details.html"><img src="images/blog/square1.jpg" alt="images" /></Link>
                            <div className="post-right">
                                <h5 className="post-title mt-0"><Link to="news-details.html">Sustainable Construction</Link></h5>
                                <p>Lorem ipsum dolor...</p>
                            </div>
                        </article>
                        <article className="post clearfix pb-0 mb-10">
                            <Link tos="post-thumb" to="news-details.html"><img src="images/blog/square2.jpg" alt="images" /></Link>
                            <div className="post-right">
                                <h5 className="post-title mt-0"><Link to="news-details.html">Industrial Coatings</Link></h5>
                                <p>Lorem ipsum dolor...</p>
                            </div>
                        </article>
                        <article className="post clearfix pb-0 mb-10">
                            <Link tos="post-thumb" to="news-details.html"><img src="images/blog/square3.jpg" alt="images" /></Link>
                            <div className="post-right">
                                <h5 className="post-title mt-0"><Link to="news-details.html">Storefront Installations</Link></h5>
                                <p>Lorem ipsum dolor...</p>
                            </div>
                        </article>
                    </div>
                </div>

                <div className="widget">
                    <h5 className="widget-title widget-title-line-bottom line-bottom-theme-colored1">Contact Info</h5>
                    <div className="tm-widget-contact-info contact-info-style1 contact-icon-theme-colored1">
                        <ul>
                            <li className="contact-name">
                                <div className="icon"><i className="flaticon-contact-037-address"></i></div>
                                <div className="text">John Doe</div>
                            </li>
                            <li className="contact-phone">
                                <div className="icon"><i className="flaticon-contact-042-phone-1 font-icon"></i></div>
                                <div className="text"><Link to="tel:+510-455-6735">+510-455-6735</Link></div>
                            </li>
                            <li className="contact-email">
                                <div className="icon"><i className="flaticon-contact-043-email-1"></i></div>
                                <div className="text"><Link to="mailto:info@yourdomain.com">info@yourdomain.com</Link></div>
                            </li>
                            <li className="contact-address">
                                <div className="icon"><i className="flaticon-contact-047-location"></i></div>
                                <div className="text">3982 Browning Lane Carolyns Circle, California</div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div id="wrapper" className="clearfix">
            <header id="header" className="header header-layout-type-header-2rows">
                <div className="header-top border-bottom-theme-color-2-1px">
                    <div className="container p-0">
                        <div className="row">
                            <div className="col-xl-auto header-top-left align-self-center text-center text-xl-left">
                                <ul className="element contact-info">
                                    <li className="contact-phone"><i className="flaticon-contact-042-phone-1 font-icon"></i> Hotline : 16259</li>
                                    <li className="contact-email"><i className="flaticon-contact-043-email-1 font-icon sm-display-block"></i> info@saudigermanacademy.com</li>
                                    {/* <li className="contact-address"><i className="fa fa-map font-icon sm-display-block"></i> 121 King Street, Melbourne</li> */}
                                </ul>
                            </div>
                            <div className="col-xl-auto ms-xl-auto header-top-right align-self-center text-center text-xl-right">
                                <div className="element pt-0 pb-0">
                                    <ul className="styled-icons icon-dark icon-theme-colored1 icon-circled clearfix">
                                        <li><Link className="social-link" to="https://www.facebook.com/SGHAcademy?mibextid=9R9pXO" ><i className="fab fa-facebook"></i></Link></li>
                                        <li><Link className="social-link" to="https://www.linkedin.com/company/saudigermanacademy/" ><i className="fab fa-linkedin"></i></Link></li>
                                        <li><Link className="social-link" to="https://www.instagram.com/sgacademyy/" ><i className="fab fa-instagram"></i></Link></li>
                                        {/* <li><Link className="social-link" to="" ><i className="fab fa-youtube"></i></Link></li> */}
                                    </ul>
                                </div>
                                <div className="element pt-0 pt-lg-10 pb-0">
                                    <div className="btn btn-theme-colored2 btn-sm ajaxload-popup" onClick={handleDownload}>
                                        <i class="me-2 fa fa-solid fa-download"></i>
                                        Download Calendar</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="header-nav tm-enable-navbar-hide-on-scroll">
                    <div className="header-nav-wrapper navbar-scrolltofixed">
                        <div className="menuzord-container header-nav-container">
                            <div className="container-fluid position-relative px-5">
                                <div className="row header-nav-col-row justify-content-around">
                                    <div className="col-sm-auto align-self-center">
                                        <Link className="menuzord-brand site-brand" to="">
                                            <img className="logo-default logo-1x" src="images/horizontal.png" alt="Logo" />
                                            <img className="logo-default logo-2x retina" src="images/horizontal.png" alt="Logo" />
                                        </Link>
                                    </div>
                                    <div className="col-sm-auto pr-0 align-self-center">

                                        <nav class="navbar navbar-expand-lg navbar-light menuzord-menu menuzord-right menuzord-indented scrollable">
                                            <div class="container-fluid">
                                                <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                                                    <span class="navbar-toggler-icon"></span>
                                                </button>
                                                <div class="collapse navbar-collapse" id="navbarSupportedContent" ref={collapseRef}>
                                                    <button className="menu-close-btn" onClick={closeNav}>
                                                        &times;
                                                    </button>
                                                    <ul class="navbar-nav me-auto mb-2 mb-lg-0 menuzord-menu menuzord-right menuzord-indented scrollable">
                                                        <li class="nav-item menu-item p-0">
                                                            <NavLink className={({ isActive }) => isActive ? 'active' : ''} aria-current="page" to="/" onClick={() => {
                                                                closeNav();
                                                                scrollToTop()
                                                            }}>Home</NavLink>
                                                        </li>
                                                        <li class="nav-item menu-item p-0">
                                                            <NavLink className={({ isActive }) => isActive ? 'active' : ''} onClick={() => {
                                                                closeNav();
                                                                scrollToTop()
                                                            }} to='about' >About Us</NavLink>
                                                        </li>
                                                        <li class="nav-item menu-item p-0">
                                                            <NavLink className={({ isActive }) => isActive ? 'active' : ''} to="courses" onClick={() => {
                                                                closeNav();
                                                                scrollToTop()
                                                            }}>Our Courses</NavLink>
                                                        </li>
                                                        <li class="nav-item menu-item p-0">
                                                            <NavLink className={({ isActive }) => isActive ? 'active' : ''} to="training-events-calender" onClick={() => {
                                                                closeNav();
                                                                scrollToTop()
                                                            }}>Training &
                                                                Events Calendar</NavLink>
                                                        </li>
                                                        {/* <li class="nav-item menu-item p-0">
                                                            <NavLink to="our-parnters" onClick={closeNav}>Our Parnters</NavLink>
                                                        </li> */}
                                                        <li class="nav-item menu-item p-0">
                                                            <NavLink className={({ isActive }) => isActive ? 'active' : ''} to='media-center' onClick={() => {
                                                                closeNav();
                                                                scrollToTop()
                                                            }}>
                                                                Media Center
                                                            </NavLink>

                                                        </li>

                                                    </ul>

                                                </div>
                                            </div>
                                        </nav>
                                    </div>
                                    {/* <div className="col-sm-auto align-self-center nav-side-icon-parent px-0">
                                        <ul className="list-inline nav-side-icon-list">
                                            <li className="hidden-mobile-mode"><Link to="/" id="top-nav-search-btn"><i className="search-icon fa fa-search"></i></Link></li>
                                            <li className="hidden-mobile-mode">
                                                <div id="side-panel-trigger" className="side-panel-trigger">
                                                    <Link to="/">
                                                        <div className="hamburger-box">
                                                            <div className="hamburger-inner"></div>
                                                        </div>
                                                    </Link>
                                                </div>
                                            </li>
                                        </ul>
                                        <div id="top-nav-search-form" className="clearfix">
                                            <form>
                                                <input type="text" name="s" placeholder="Type and Press Enter..." autocomplete="off" />
                                            </form>
                                            <Link to="/" id="close-search-btn"><i className="fa fa-times"></i></Link>
                                        </div>
                                    </div> */}
                                </div>
                                {/* <div className={`row ${isNavOpen ? 'd-block' : 'd-none'} `}>
                                    <div className="col-12">
                                        <nav id="top-primary-nav-clone" className="menuzord d-block d-xl-none default menuzord-color-default menuzord-border-boxed menuzord-responsive" data-effect="slide" data-animation="none" data-align="right">
                                            <ul id="main-nav-clone" className="menuzord-menu menuzord-right menuzord-indented scrollable">
                                                <li className="active menu-item">
                                                    <Link to="/" onClick={closeNavbar}>Home</Link>
                                                </li>
                                                <li className="menu-item">
                                                    <Link to='about' onClick={closeNavbar}>About Us</Link>
                                                </li>
                                                <li className="menu-item"><Link to="courses" onClick={closeNavbar}>Our Courses</Link>
                                                </li>
                                                <li className="menu-item"><Link to="training-events-calender" onClick={closeNavbar}>Training &
                                                    Events Calendar</Link>
                                                </li>

                                                <li className="menu-item">
                                                    <Link to="/our-parnters" onClick={closeNavbar}>Our Parnters</Link>

                                                </li>
                                                <li className="menu-item" onClick={toggleSubmenu}>
                                                    <Link to="" >
                                                        News & Media
                                                        <span className="indicator">
                                                            <i className="fa fa-angle-down"></i>
                                                        </span>
                                                    </Link>
                                                    <div
                                                        className={`megamenu megamenu-fullwidth megamenu-position-left ${isOpen ? 'show' : ''}`}
                                                        style={{
                                                            left: 'auto',
                                                            maxWidth: '100%',
                                                            right: 'auto',
                                                            width: 'auto'
                                                        }}
                                                    >
                                                        <div className="megamenu-row">
                                                            <div className="col12">
                                                                <ul className="list-unstyled list-dashed">
                                                                    <li className="menu-item">
                                                                        <ul className="list-unstyled">
                                                                            <li>
                                                                                <Link to="" onClick={closeNavbar}>
                                                                                    News
                                                                                </Link>
                                                                            </li>
                                                                            <li>
                                                                                <Link to="" onClick={closeNavbar}>
                                                                                    Media Coverage
                                                                                </Link>
                                                                            </li>
                                                                        </ul>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li className="menu-item">
                                                    <Link to="/contact-us" onClick={closeNavbar}> contact us</Link>

                                                </li>
                                                <li className="scrollable-fix"></li>
                                            </ul>
                                        </nav>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        </div>
    </>
}
